import {useEffect, useState} from "react";
import { useAppSelector } from "redux-share/hooks";
import { ISprayEmojiProps } from "interfaces";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const AnimatedEmoji = dynamic(() => import("./animatedEmoji/AnimatedEmoji"));

const SprayEmoji = ({ codes, direction }: ISprayEmojiProps) => {

    const [emojiBucket, setEmojiBucket] = useState<string[]>([]);
    const [shuffledEmojiBucket, setShuffledEmojiBucket] = useState<string[]>([]);
    const [timeoutIds, setTimeoutIds] = useState<any[]>([]);

    const { config } = useAppSelector(({ videoData: { config } }) => ({ config }), shallowEqual);

    const RetrievalAndShuffle = () => {
        let ShuffleEmoji = (codes.map((a) => ({
            sort: Math.random(),
            value: a
        })).sort((a, b) => a.sort - b.sort).map((a) => a.value));
        setShuffledEmojiBucket(ShuffleEmoji);
    }

    useEffect(() => {
        setShuffledEmojiBucket([]);
        setEmojiBucket([]);
        RetrievalAndShuffle();
    }, [codes]);

    useEffect(() => {
        let timeOutId1:any;
        let timeOutId2:any;
        let timeOutId3:any;
        let timeOutId4:any;
        if (shuffledEmojiBucket.length > 0) {
            for (let i = 0; i < shuffledEmojiBucket.length; i++) {
                timeOutId1 = setTimeout(() => {
                    setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[i]]);
                    timeOutId2 = setTimeout(() => {
                        setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[i]]);
                        timeOutId3 = setTimeout(() => {
                            setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[i]]);
                            timeOutId4 = setTimeout(() => {
                                setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[i]]);
                            }, 170);
                        }, 170);
                    }, 170);
                }, (config.get_interval / shuffledEmojiBucket.length) * 1000 * i);
                setTimeoutIds((prev) => [...prev, timeOutId1 , timeOutId2 , timeOutId3 , timeOutId4]);
            }
        }
        return ()=> {
            if (timeoutIds.length > 0) {
                timeoutIds.forEach((id) => clearTimeout(id));
                setTimeoutIds([]);
            }
        }
    }, [shuffledEmojiBucket]);
    return (
        <div>
            {
                emojiBucket.length > 0 ? emojiBucket.map((item, index) => {
                        return (
                            <div key={index}>
                                <AnimatedEmoji direction={direction} emojiCode={item}/>
                            </div>
                        )
                    }) :
                    <></>
            }
        </div>
    )
}

export default SprayEmoji;